import type { Room } from "building-types/rooms/roomTypes";

/**
 * It's important that we have a consistent way to produce room names as they are typically displayed in plans.
 * RoomType.nameInPlan is not always populated and we need to be able to use fallback values. The functions
 * below are aim to produce consistent room names given different inputs.
 */

/**
 * Formats the room name for the KAM consistent with implementation in lib/house/plans/selectors.ts
 * @param room - Room object returned from buildingQueryControllers.ROOM.
 * @returns The formatted room name.
 */

export function roomNameFromAttributes(roomType: string, nameInPlan?: string): string {
  const roomTypeUpperCase = roomType.toUpperCase();

  return !nameInPlan || nameInPlan === " " || nameInPlan === "" ? roomTypeUpperCase : nameInPlan;
}

/**
 * returns formatted room name from Room building type
 * @param room - The Room building type
 * @returns The formatted room name.
 */

export function roomNameFromBuildingRoom(room: Room): string {
  return roomNameFromAttributes(room.attributes.name, room.nameInPlan);
}
